import { render, staticRenderFns } from "./five.vue?vue&type=template&id=4492c83f&scoped=true&"
import script from "./five.vue?vue&type=script&lang=js&"
export * from "./five.vue?vue&type=script&lang=js&"
import style0 from "./five.vue?vue&type=style&index=0&id=4492c83f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4492c83f",
  null
  
)

export default component.exports